export default __webpack_public_path__ + "static/filter-c75e43b7ae1d157f3e99c4f4763b6003.svg";